import React, { useMemo } from 'react';
import type {
    PageBuilderModuleMetaProps,
    TextColumnProps,
} from '@modules/page-builder/types';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';

interface HtmlModuleDisplayProps extends PageBuilderModuleMetaProps {
    column: TextColumnProps;
}

/**
 * Render-only version of HtmlModule.
 * Expects the backend to surface HTML at `column.contentHTML`.
 */
const HtmlModuleDisplay = ({ column, meta }: HtmlModuleDisplayProps) => {
    const previewHtml = useMemo(
        () => column?.parsedContent ?? '',
        [column?.parsedContent],
    );

    const clickProxy = useWebsiteTrackingProxy({
        professionalID: meta?.professional?.id,
        professionalTitle: meta?.professional?.title,
        itemType: meta?.itemType,
    });

    if (!previewHtml) return null;

    return (
        <div
            className="cms-inline-html"
            onClick={clickProxy}
            onContextMenu={clickProxy}
            dangerouslySetInnerHTML={{ __html: previewHtml }}
        />
    );
};

export default HtmlModuleDisplay;
